import { css } from '@emotion/react';
import { breakpoints } from '../../../styles';
import { SecondaryProps, p2r } from '../../../styles/fonts';

const styles = ({
  maxWidth,
  width,
  fontSize,
  lineHeight,
  fontWeight,
  letterSpacing = '-1.4px',
  mobileLetterSpacing = '-1.2px',
}) => css`
  width: ${width};
  max-width: ${maxWidth};
  margin: 0;
  font-size: ${p2r(fontSize)};
  font-weight: ${fontWeight};
  line-height: ${p2r(lineHeight)};
  letter-spacing: ${letterSpacing};

  @media (max-width: ${breakpoints.netbook}px) {
    font-size: ${p2r(34)};
    line-height: ${p2r(48)};
    letter-spacing: ${mobileLetterSpacing};
  }

  @media (max-width: ${breakpoints.hugeMobile}px) {
    font-size: ${p2r(28)};
    line-height: ${p2r(31)};
  }

  ${SecondaryProps}
`;

export default styles;
